
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import { MenuItem, FormControl, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { CircularProgress, Backdrop } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE } from "constants.js";
import configurationContext from "contextConfig";
import { useMaterialUIController, setLogContext } from "context";
import MDTypography from "components/MDTypography";
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import { styled } from '@mui/material/styles';

function InfoLog() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [responseData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const [responseResultCount, setResponseResultCount] = useState(0);
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { logContext } = controller;

  var pageSelected = 1;
  const { pageNo } = useParams();

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const clearLog = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/clear-log",
      method: "POST",
      data: { source: logContext.source, logType: logContext.logType },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    })
      .then(function (response) {
        setIsLoading(false)
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setData({});
            setResponseResultCount(0);
            toast.success(t('logCleared'))
          }
          else {
            toast.error(t(message))
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  const data = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/log-details?page=" + pageSelected + "&source=" + logContext.source + "&logType=" + logContext.logType,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    })
      .then(function (response) {
        setIsLoading(false)
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setData(response.data);
            if (response.data.data && response.data.data.totalCount) {
              setResponseResultCount(response.data.data.totalCount);
            }
          }
          else {
            toast.error(t(message))
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      minWidth: "500px",
      maxHeight: 300,
      overflowY: 'auto',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  const columns = [
    { Header: t("timestamp"), accessor: "timestamp", align: "left" },
    { Header: t("level"), accessor: "level", align: "left" },
    { Header: t("message"), accessor: "message", align: "left", },
  ];

  const finalObj = [];
  if (responseData.data && responseData.data.rows) {
    let logRecords = responseData.data.rows;
    for (const rowKey in logRecords) {
      if (logRecords[rowKey]) {
        let logRecord = JSON.parse(logRecords[rowKey]);
        let tempObj = {
          timestamp: logRecord.timestamp,
          level: logRecord.level,
          message: ((logRecord.message).length <= 60) ? logRecord.message : <HtmlTooltip title={logRecord.message}>
            <MDTypography component="span" className="tooltipMessage" variant="body3" color="text"> {(logRecord.message).substring(0, 60)}<ReadMoreIcon className="readMoreIcon" /></MDTypography>
          </HtmlTooltip>
        };
        finalObj.push(tempObj);
      }
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("systemLogs")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={1} pb={2} className="ContentSectionBox">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
              <Grid container className="FilterSectionBox" spacing={2}>
                <Grid item xs={12} sm={3} md={3} >
                  <MDInput
                    select
                    name="source"
                    label={t('source')}
                    value={logContext.source}
                    InputProps={{
                      classes: { root: "filterStyle" },
                    }}
                    onChange={(obj) => {
                      setLogContext(dispatch, { ...logContext, source: obj.target.value });
                    }}
                    fullWidth
                  >
                    <MenuItem value={'admin'}>{t('admin')}</MenuItem>
                    <MenuItem value={'vendor'}>{t('vendor')}</MenuItem>
                  </MDInput>
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  <MDInput
                    select
                    name="logType"
                    label={t('logType')}
                    value={logContext.logType}
                    InputProps={{
                      classes: { root: "filterStyle" },
                    }}
                    onChange={(obj) => {
                      setLogContext(dispatch, { ...logContext, logType: obj.target.value });
                    }}
                    fullWidth
                  >
                    <MenuItem value={'error'}>{t('error')}</MenuItem>
                    <MenuItem value={'info'}>{t('info')}</MenuItem>
                  </MDInput>
                </Grid>
                <Grid item xs={12} sm={2} md={2} >
                  <FormControl className="filterSubmit">
                    <MDButton
                      onClick={() => {
                        navigate("/admin/infoLog");
                        if (typeof pageNo === "undefined")
                          data();
                      }}
                      key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple fullWidth>{t('viewLogs')}
                    </MDButton>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("log", "read") && checkPrivilege("log", "delete")))) ?
                    <FormControl className="filterSubmit">
                      <MDButton
                        onClick={() => {
                          clearLog();
                        }}
                        key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple fullWidth>{t('clearLogs')}
                      </MDButton>
                    </FormControl>
                    :
                    null}
                </Grid>
              </Grid>
            </MDBox>

            <MDBox pt={3}>
              <DataTable
                table={{ columns, rows }}
                isSorted={false}
                showTotalEntries={true}
                responseResultCount={responseResultCount}
                paginationSize={MyContext.paginationSize}
                paginationLink={"/admin/infoLog/page-"}
                pageSelected={pageSelected}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default InfoLog;
